"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class AssetConsumptionBatch extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetConsumptionBatch';
        this.isListening = true;
        this._assetId = initParams.asset_id;
        this._assetName = initParams.asset_name;
        this._siteName = initParams.site_name;
        this._parent = initParams.parent;
        this._siteId = initParams.site_id;
        this._type = initParams.type;
        this._telemetry = (0, util_1.camelArray)(initParams.telemetry);
        this._currency = initParams.currency;
        this._deviceCategory = initParams.device_category;
        this._deviceCategoryId = initParams.device_category_id;
        this._colour = initParams.colour;
        this._loadType = initParams.load_type;
        this._icon = initParams.icon;
        this._noTariff = initParams.no_tariff;
    }
    set assetId(value) {
        console.error('Do not set objects this way');
    }
    get assetId() {
        return this._assetId;
    }
    set assetName(value) {
        console.error('Do not set objects this way');
    }
    get assetName() {
        return this._assetName;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    get siteName() {
        return this._siteName;
    }
    set parent(value) {
        console.error('Do not set objects this way');
    }
    get parent() {
        return this._parent;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    get siteId() {
        return this._siteId;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    get type() {
        return this._type;
    }
    set telemetry(value) {
        console.error('Do not set objects this way');
    }
    get telemetry() {
        return this._telemetry;
    }
    set currency(value) {
        console.error('Do not set objects this way');
    }
    get currency() {
        return this._currency;
    }
    set deviceCategory(value) {
        console.error('Do not set objects this way');
    }
    get deviceCategory() {
        return this._deviceCategory;
    }
    set deviceCategoryId(value) {
        console.error('Do not set objects this way');
    }
    get deviceCategoryId() {
        return this._deviceCategoryId;
    }
    set colour(value) {
        console.error('Do not set objects this way');
    }
    get colour() {
        return this._colour;
    }
    set loadType(value) {
        console.error('Do not set objects this way');
    }
    get loadType() {
        return this._loadType;
    }
    set icon(value) {
        console.error('Do not set objects this way');
    }
    get icon() {
        return this._icon;
    }
    set noTariff(value) {
        console.error('Do not set objects this way');
    }
    get noTariff() {
        return this._noTariff;
    }
}
exports.default = AssetConsumptionBatch;
//# sourceMappingURL=assetConsumptionBatch.js.map